import appComponents from './ms-MY/appComponents';
import appPages from './ms-MY/appPages';
import common from './ms-MY/common';
import component from './ms-MY/component';
import globalHeader from './ms-MY/globalHeader';
import menu from './ms-MY/menu';
import pages from './ms-MY/pages';
import pwa from './ms-MY/pwa';
import settingDrawer from './ms-MY/settingDrawer';
import settings from './ms-MY/settings';

export default {
  'navBar.lang': 'Bahasa',
  'layout.user.link.help': 'Bantuan',
  'layout.user.link.privacy': 'Privasi',
  'layout.user.link.terms': 'Terma',
  'app.copyright.produced': 'Produced by Ant Financial Experience Department',
  'app.preview.down.block': 'Download this page to your local project',
  'app.welcome.link.fetch-blocks': 'Get all block',
  'app.welcome.link.block-list': 'Quickly build standard, pages based on `block` development',
  'login.forgotPassword.support': 'Lupa Kata Laluan',
  ...globalHeader,
  ...menu,
  ...settingDrawer,
  ...settings,
  ...pwa,
  ...component,
  ...pages,
  ...common,
  ...appPages,
  ...appComponents,
};
